export const safeJsonParse = (data) => {
  try {
    if (typeof data === "object" && data !== null) {
      // Already parsed
      return data;
    }

    if (typeof data === "string") {
      let parsed = data;

      // Keep parsing while it's a valid JSON string
      while (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch {
          break;
        }
      }

      return parsed && typeof parsed === "object" ? parsed : {};
    }

    return {};
  } catch {
    return {};
  }
};
